import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import i18next from "i18next"
import i18n from "./i18n/i18n" // eslint-disable-line no-unused-vars
import LoggedInApp from "./LoggedInApp"
import LoggedOutApp from "./LoggedOutApp"
import { ROUTES } from "./constants"
import UserDetailsShape from "./state/shapes/UserDetailsShape"

class App extends Component {
  static propTypes = PropTypes.shape(UserDetailsShape).isRequired

  render() {
    const { userDetails } = this.props

    // When we the user is authenticated we will have the client id and
    // the users preferred culture so we should load these up.
    if (userDetails.authenticated) {
      const clientTranslation = `translations.${userDetails.client.id}`
      i18next.loadNamespaces(clientTranslation)
      i18next.setDefaultNamespace(clientTranslation)
      i18next.changeLanguage(userDetails.culture)
    }

    // Store the initial location as if we are redirected to authenticate
    // we want to be able to hit this URL as soon as we can.
    if (!sessionStorage.nextLocation) {
      if (window.location.pathname.indexOf("/static/") === 0) {
        sessionStorage.nextLocation = ROUTES.dashboards.peopleBalanceSheet
      } else {
        sessionStorage.nextLocation = window.location.pathname
      }
    }

    return <div>{userDetails.authenticated ? <LoggedInApp /> : <LoggedOutApp />}</div>
  }
}

function mapStateToProps(state) {
  return {
    userDetails: state.userDetail,
  }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/App.jsx